/**
 * @file The working hours insight component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LocalisationService } from '../../core/localisation.service';
import { InsightService } from '../insight.service';
import { InsightTableComponent } from '../insight-table/insight-table.component';
import { InsightProvider } from '../insight-provider';
import { ComponentRegistry } from '../../core/component-registry';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Insight component that shows a table
 */
var InsightWorkingHoursComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightWorkingHoursComponent, _super);
    /**
     * Constructs an InsightWorkingHoursComponent.
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightWorkingHoursComponent(resourceService, provider, insightService, localisationService, router, translateService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.translateService = translateService;
        _this.alertsService = alertsService;
        /**
         * Contains the date of horizon within the view.
         * @private
         */
        _this.horizonDate = moment().startOf('day');
        _this.makeHorizonDateListener(_this.subscriptionPool, router, function (value) {
            _this.horizonDate = value;
            _this.refresh();
        });
        return _this;
    }
    /**
     * Register component by the insight provider
     */
    InsightWorkingHoursComponent.register = function () {
        ComponentRegistry.register('insight', 'InsightWorkingHoursComponent', InsightWorkingHoursComponent);
    };
    Object.defineProperty(InsightWorkingHoursComponent.prototype, "start", {
        /**
         * Gets the start of week with respect to startTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var start = this.horizonDate.clone().startOf('isoWeek');
            start.add(this.startOffset, 'week');
            return start.toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightWorkingHoursComponent.prototype, "finish", {
        /**
         * Gets finish of week with respect to endTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var date = this.horizonDate.clone().endOf('isoWeek');
            date.add(this.finishOffset, 'week');
            var finish = date.toDate();
            if (finish > this.publishedTill) {
                finish = this.publishedTill;
            }
            return finish;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightWorkingHoursComponent.prototype, "startOffset", {
        /**
         * Gets the offset of the start in weeks relative to the horizon date.
         * @readonly
         * @private
         * @type {number}
         */
        get: function () {
            var offset = 0;
            if (this.configuration && this.configuration.data && this.configuration.data.startTimeOffset) {
                offset = this.configuration.data.startTimeOffset;
            }
            return offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightWorkingHoursComponent.prototype, "finishOffset", {
        /**
         * Gets the offset of the finish in weeks relative to the horizon date.
         * @readonly
         * @private
         * @type {number}
         */
        get: function () {
            var offset = 0;
            if (this.configuration && this.configuration.data && this.configuration.data.endTimeOffset) {
                offset = this.configuration.data.endTimeOffset;
            }
            return offset;
        },
        enumerable: true,
        configurable: true
    });
    /** Handle for the after items loaded event */
    InsightWorkingHoursComponent.prototype.afterItemsLoaded = function () {
        var _this = this;
        // Start with an empty items array
        var items = [];
        // Pre-define x-axis: today and the four days after
        for (var days = 0; days < 5; days += 1) {
            items.push({
                name: this.getAxisLabel(this.horizonDate.clone().add(days, 'days')),
                value: this.translateService.instant('APP.INSIGHTS.WORKING_HOURS.NONE')
            });
        }
        // Run through the loaded items
        this.loadedItems.splice(0, 5).forEach(function (loadedItem) {
            // Prepare the start and stop time
            var startTime = moment(loadedItem['minimum']).format('HH:mm');
            var stopTime = moment(loadedItem['maximum']).format('HH:mm');
            var date = moment(loadedItem['date']);
            // Find the item and add the values
            var name = _this.getAxisLabel(date);
            var item = items.find(function (i) { return i.name === name; });
            if (item) {
                item.value = startTime + ' - ' + stopTime;
            }
        });
        // Set the data
        this.setData(items);
    };
    /**
     * Returns a label for the x-axis based on the date it represents.
     * @param date The date from which a string is derived.
     * @returns The date relative to today, plus day and month.
     */
    InsightWorkingHoursComponent.prototype.getAxisLabel = function (date) {
        return date.calendar(null, this.localisationService.calendarRelativeOptions()) + ' (' + date.format(this.localisationService.shortDate.format) + ')';
    };
    return InsightWorkingHoursComponent;
}(InsightTableComponent));
export { InsightWorkingHoursComponent };
